import http from '../services/httpServiceHealthCare'

const USERINFO_URL = '/UserInfos'

// Resolve a patient's userId (and name) from their cId.
export const getUserInfoByCid = async (cId) => {
  const response = await http.get(USERINFO_URL, {
    params: {
      filter: {
        where: { cId },
        fields: ['userId', 'cId', 'firstName', 'lastName'],
        limit: 1,
      },
    },
  })
  return response.data
}

// Same endpoint the mobile "ประวัติ" tab uses (PatientHIEBookingHistory).
// Returns { docs: [...] } where each visit doc carries embedded labResults.
export const getVisitsByPatientId = async (patientId, page = 1, limit = 20) => {
  const response = await http.get(`${USERINFO_URL}/newCheckUserVisitedByVerifiedFromHIE`, {
    params: { patientId, page, limit },
  })
  return response.data
}

// Same endpoint the mobile AppointmentList screen uses
// ("รายการนัดหมายแพทย์ที่โรงพยาบาล"). Backend resolves patientId -> hnId -> HIE
// appointments. Returns { docs: [...] } of raw HIE appointment objects.
export const getAppointmentsByPatientId = async (patientId, page = 1, limit = 40) => {
  const response = await http.get(`${USERINFO_URL}/getAppointments`, {
    params: { patientId, page, limit },
  })
  return response.data
}
